import {businessCalendarDate} from 'src/api/business-time'
import {parseApiDate, toApiDateString} from 'src/jobs/job-schedule-format'

export type DispatchReportSearch = {
    date?: string
}

export function validateDispatchReportSearch(
    search: Record<string, unknown>,
): DispatchReportSearch {
    const date = search['date']
    if (typeof date === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(date)) {
        return {date}
    }
    return {}
}

function businessCalendarTomorrow(from = new Date()) {
    const tomorrow = businessCalendarDate(from)
    tomorrow.setDate(tomorrow.getDate() + 1)
    return tomorrow
}

export function defaultDispatchReportDate() {
    return businessCalendarTomorrow()
}

export function resolveDispatchReportDate(search: DispatchReportSearch) {
    if (search.date) {
        return parseApiDate(search.date)
    }
    return defaultDispatchReportDate()
}

export function dispatchReportDateSearchValue(date: Date) {
    return toApiDateString(date)
}

export function parseDateInputValue(value: string | Date | null) {
    if (value == null) {
        return null
    }
    if (value instanceof Date) {
        return value
    }
    if (/^\d{4}-\d{2}-\d{2}$/.test(value)) {
        return parseApiDate(value)
    }
    return new Date(value)
}
